module.exports = __webpack_public_path__ + "static/media/slider-home-architecture-slide-bg.7309c2f3.jpg";